import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class DepartmentService {
  list = async ({ departmentId }) => {
    try {
      const params = qs.stringify({
        ...(departmentId && { departmentId }),
      });

      const response = await HttpClient.get(`/api/department/list?${params}`);
      //   console.log(response);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  updateStatus = async (body) => {
    try {
      const response = await HttpClient.post(
        `/api/employee/updatestatus`,
        body
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  updateDepartment = async (body) => {
    try {
      const response = await HttpClient.post(`/api/department/add`, body);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
  AddDepartment = async (data) => {
    try {
      const response = await HttpClient.post("/api/department/add", data);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  listPrintFile = async (body) => {
    try {
      const params = qs.stringify(body);

      const response = await HttpClient.get(
        `/api/visaformadmin/configsmartdepartmentupload/list?${params}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
}

export default new DepartmentService();
